import React from "react";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  Brush,
  Bar,
  ReferenceLine,
  BarChart,
} from "recharts";

function LineChartMonitoring({
  data,
  KeyXAxis = "",
  KeyYAxis = "",
  lineColor = "#063F5E",
  lineStrokeWidth = 1,
  KeyYAxisShow = false,
  GridVertical = false,
  GridHorizontal = false,
  height = 150,
  brushShow = false,
  graficType = "LineChart",
  refCenterShow = false,
  refCenterPosition = 0,
  refCenterColor = "",
  refMaxShow = false,
  refMaxPosition = 0,
  refMaxColor = "",
  refMinShow = false,
  refMinPosition = 0,
  refMinColor = "",
}) {
  const CustomGrafic = graficType === "Barras" ? BarChart : LineChart;
  const CustomShowMod = graficType === "Barras" ? Bar : Line;

  return (
    <ResponsiveContainer width="100%" height={height}>
      <CustomGrafic width="100%" height={height} data={data}>
        <CartesianGrid
          vertical={GridVertical}
          horizontal={GridHorizontal}
          strokeDasharray="3 3"
        />
        <Tooltip
          labelFormatter={(value) => {
            return `data: ${value}`;
          }}
        />
        {KeyYAxisShow && <YAxis data={KeyYAxis} tickCount={data.length} />}

        <XAxis
          dataKey={KeyXAxis}
          hide={!KeyYAxisShow}
          interval="preserveStartEnd"
          tickFormatter={(value, index) => index}
        />

        <CustomShowMod
          type="monotone"
          dataKey={KeyYAxis}
          stroke={lineColor}
          fill={lineColor}
          strokeWidth={lineStrokeWidth}
          dot={false}
        />

        {refCenterShow && (
          <ReferenceLine y={refCenterPosition} stroke={refCenterColor} />
        )}
        {refMaxShow && (
          <ReferenceLine label="Max" y={refMaxPosition} stroke={refMaxColor} />
        )}
        {refMinShow && (
          <ReferenceLine label="Min" y={refMinPosition} stroke={refMinColor} />
        )}

        {brushShow && <Brush height={30} stroke="#1E729F" />}
      </CustomGrafic>
    </ResponsiveContainer>
  );
}

export function arePropsEqualLineChartMonitoring(prevProps, nextProps) {
  const listPropsText = [
    "data",
    "KeyXAxis",
    "KeyYAxis",
    "lineColor",
    "lineStrokeWidth",
    "KeyYAxisShow",
    "GridVertical",
    "GridHorizontal",
    "height",
    "brushShow",
    "graficType",
    "refCenterShow",
    "refCenterPosition",
    "refCenterColor",
    "refMaxShow",
    "refMaxPosition",
    "refMaxColor",
    "refMinShow",
    "refMinPosition",
    "refMinColor",
  ];
  if (listPropsText.every((props) => prevProps[props] === nextProps[props])) {
    return true;
  }
  return false;
}

export default React.memo(
  LineChartMonitoring,
  arePropsEqualLineChartMonitoring
);
